export default class audioplay {
  constructor(item) {
    this.audio = $(item).find('audio').get(0);
    this.timelineWrap = $(item).find('.timeline').get(0);
    this.timeline = $(item).find('.timeline--elapsed').get(0);
    this.playing = false;
    this.playbut = $(item).find('.playbut');

    this.time = $(item).find('.current-time');

    var parent = this;

    this.audio.oncanplay = function(){
      let min = parseInt(this.duration / 60);
      let s = parseInt((parseFloat(this.duration / 60) - min) * 60);
      min = min < 10 ? '0'+min : min;
      s = s < 10 ? '0'+s : s;
      let durStr = min+':'+s;
      $(item).find('.duration').text(durStr);
    }

    $(this.playbut).click(function(e){
      e.preventDefault();
      if(parent.audio.paused){
        $(this).attr('data-state', 'pause');
        parent.audio.muted = false;
        parent.audio.play();
      } else {
        $(this).attr('data-state', 'play');
        parent.audio.muted = true;
        parent.audio.pause();
      }
    });

    $(item).find('.reel-back').click(function(e){
      e.preventDefault();
      parent.audio.currentTime -= 15;
      parent.audio.ontimeupdate();
      parent.audio.play();
      parent.audio.muted = false;
      $(parent.playbut).attr('data-state','pause');
      $(parent.playbut).addClass('load');
    });

    $(item).find('.reel-forward').click(function(e){
      e.preventDefault();
      parent.audio.currentTime += 15;
      parent.audio.ontimeupdate();
      parent.audio.play();
      parent.audio.muted = false;
      $(parent.playbut).attr('data-state','pause');
      $(parent.playbut).addClass('load');
    });

    this.audio.ontimeupdate = function(){
      let playedPrc = this.currentTime / this.duration;
      parent.timeline.style.width = playedPrc*100+'%';

      let min = parseInt(this.currentTime / 60);
      min = min < 10 ? '0'+min : min;
      let s = parseInt((parseFloat(this.currentTime / 60) - min) * 60);
      s = s < 10 ? '0'+s : s;
      let curStr = min+':'+s;
      $(parent.time).text(curStr);

      $(parent.playbut).removeClass('load');
    }

    this.audio.onseek = function(){
      let playedPrc = this.currentTime / this.duration;
      parent.timeline.style.width = playedPrc*100+'%';
      parent.audio.play();
      parent.audio.muted = false;
      $(parent.playbut).attr('data-state','pause');
    }

    this.timelineWrap.onmousemove = function(e){ move(e) };
    this.timelineWrap.ontouchmove = function(e){ move(e) };

    function move(e){
      // console.log(e);
      if(e.type=='touchmove') e = e.touches[0];
      var xPos = e.offsetX || e.clientX-$(e.target).offset().left; //-$(e)
      // console.log(xPos);
      if(parent.isMousedown) {
        let prc = xPos / parent.timelineWrap.offsetWidth;
        parent.audio.currentTime = parent.audio.duration * prc;
        parent.audio.ontimeupdate();
        $(parent.playbut).addClass('load');
      }
    }

    this.timelineWrap.onmousedown = function(){ parent.isMousedown = true; }
    this.timelineWrap.ontouchstart = function(){ parent.isMousedown = true; }

    this.timelineWrap.onmouseup = function(e){ mouseup(e); }
    this.timelineWrap.ontouchend = function(e){ mouseup(e); }

    function mouseup(e) {
      parent.isMousedown = false;
      parent.audio.play();
      parent.audio.muted = false;
      $(parent.playbut).attr('data-state','pause');
    }

    this.timelineWrap.onclick = function(e){
      let prc = e.offsetX / this.offsetWidth;
      parent.audio.currentTime = parent.audio.duration * prc;
      parent.audio.ontimeupdate();
      $(parent.playbut).addClass('load');
      // console.log(prc);
    }
  }
}
